module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ../~/lodash/first.js
// module id = 1051
// module chunks = 0